var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DsfFormControlBox", {
    staticClass: "ds-textbox",
    class: {
      "ds-textbox__has-prefix": !_vm.readOnly && _vm.valuePrefix,
      "ds-textbox-append-block__none":
        _vm.append && !_vm.isAppendGroup && !_vm.isAppendBackgroundColor,
    },
    attrs: { owner: _vm._self },
    scopedSlots: _vm._u(
      [
        _vm.inClient
          ? {
              key: "simple",
              fn: function () {
                return [
                  _c(
                    "DsfTextProxy",
                    _vm._b(
                      {
                        model: {
                          value: _vm.value,
                          callback: function ($$v) {
                            _vm.value = $$v
                          },
                          expression: "value",
                        },
                      },
                      "DsfTextProxy",
                      _vm._self.$props,
                      false
                    )
                  ),
                  _vm._t("error", function () {
                    return [
                      _vm.errors.length > 0
                        ? _c("div", { staticClass: "ds-error-text" }, [
                            _vm._v(_vm._s(_vm.errorsMsg)),
                          ])
                        : _vm._e(),
                    ]
                  }),
                ]
              },
              proxy: true,
            }
          : null,
        _vm.inClient
          ? {
              key: "content",
              fn: function () {
                return [
                  !_vm.readOnly
                    ? [
                        _vm.inputMode != "step"
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass: "el-input",
                                  class: {
                                    "ds-error-border": _vm.errors.length > 0,
                                    "is-disabled": _vm.disabled,
                                    "el-input-group":
                                      _vm.isPrefixGroup ||
                                      _vm.isAppendGroup ||
                                      _vm.append ||
                                      _vm.valuePrefix,
                                    "el-input-group--prepend":
                                      _vm.isPrefixGroup,
                                    "el-input-group--append":
                                      _vm.isAppendGroup || _vm.append,
                                    "el-input--suffix": _vm.isSuffix,
                                    "el-input--prefix": _vm.isPrefix,
                                  },
                                },
                                [
                                  _vm.valuePrefix
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ds-textbox-value-prefix",
                                        },
                                        [_vm._v(_vm._s(_vm.valuePrefix))]
                                      )
                                    : _vm._e(),
                                  _vm.isPrefixGroup
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "el-input-group__prepend",
                                        },
                                        [_vm._t("prepend")],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm.$inputType === "checkbox"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.inputValue,
                                            expression: "inputValue",
                                          },
                                        ],
                                        ref: "input",
                                        staticClass: "el-input__inner",
                                        attrs: {
                                          disabled: _vm.disabled,
                                          autocomplete: "off",
                                          placeholder: _vm.$t(_vm.placeholder),
                                          type: "checkbox",
                                        },
                                        domProps: {
                                          checked: Array.isArray(_vm.inputValue)
                                            ? _vm._i(_vm.inputValue, null) > -1
                                            : _vm.inputValue,
                                        },
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$a = _vm.inputValue,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.inputValue = $$a.concat(
                                                      [$$v]
                                                    ))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.inputValue = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.inputValue = $$c
                                              }
                                            },
                                            _vm.inputChangeHandler,
                                          ],
                                          focus: _vm.inputFocusHandler,
                                          blur: _vm.inputBlurHandler,
                                        },
                                      })
                                    : _vm.$inputType === "radio"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.inputValue,
                                            expression: "inputValue",
                                          },
                                        ],
                                        ref: "input",
                                        staticClass: "el-input__inner",
                                        attrs: {
                                          disabled: _vm.disabled,
                                          autocomplete: "off",
                                          placeholder: _vm.$t(_vm.placeholder),
                                          type: "radio",
                                        },
                                        domProps: {
                                          checked: _vm._q(_vm.inputValue, null),
                                        },
                                        on: {
                                          change: [
                                            function ($event) {
                                              _vm.inputValue = null
                                            },
                                            _vm.inputChangeHandler,
                                          ],
                                          focus: _vm.inputFocusHandler,
                                          blur: _vm.inputBlurHandler,
                                        },
                                      })
                                    : _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.inputValue,
                                            expression: "inputValue",
                                          },
                                        ],
                                        ref: "input",
                                        staticClass: "el-input__inner",
                                        attrs: {
                                          disabled: _vm.disabled,
                                          autocomplete: "off",
                                          placeholder: _vm.$t(_vm.placeholder),
                                          type: _vm.$inputType,
                                        },
                                        domProps: { value: _vm.inputValue },
                                        on: {
                                          change: _vm.inputChangeHandler,
                                          focus: _vm.inputFocusHandler,
                                          blur: _vm.inputBlurHandler,
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.inputValue = $event.target.value
                                          },
                                        },
                                      }),
                                  _vm.isPrefix
                                    ? _c(
                                        "span",
                                        { staticClass: "el-input__prefix" },
                                        [_vm._t("prefix")],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm.isSuffix
                                    ? _c(
                                        "span",
                                        { staticClass: "el-input__suffix" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-input__suffix-inner",
                                            },
                                            [_vm._t("suffix")],
                                            2
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.isAppendGroup || _vm.append
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "el-input-group__append",
                                        },
                                        [
                                          _vm._t("append", function () {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t(_vm.append)) +
                                                  " "
                                              ),
                                            ]
                                          }),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          : [
                              _c("StepTextBox", {
                                attrs: {
                                  disabled: _vm.disabled,
                                  "setp-template": _vm.setpTemplate,
                                  "split-char-in-value": false,
                                  "setp-input-temp": _vm.setpInputTemp,
                                },
                                on: {
                                  focus: _vm.inputFocusHandler,
                                  blur: _vm.inputBlurHandler,
                                },
                                model: {
                                  value: _vm.inputValue,
                                  callback: function ($$v) {
                                    _vm.inputValue = $$v
                                  },
                                  expression: "inputValue",
                                },
                              }),
                            ],
                      ]
                    : _c(
                        "div",
                        { staticClass: "ds-form-readonly" },
                        [
                          _c(
                            "DsfTextProxy",
                            _vm._b(
                              {
                                attrs: { "show-label": false },
                                model: {
                                  value: _vm.value,
                                  callback: function ($$v) {
                                    _vm.value = $$v
                                  },
                                  expression: "value",
                                },
                              },
                              "DsfTextProxy",
                              _vm._self.$props,
                              false
                            )
                          ),
                        ],
                        1
                      ),
                  _vm._t("error", function () {
                    return [
                      _vm.errors.length > 0
                        ? _c("div", { staticClass: "ds-error-text" }, [
                            _vm._v(_vm._s(_vm.errorsMsg)),
                          ])
                        : _vm._e(),
                    ]
                  }),
                ]
              },
              proxy: true,
            }
          : null,
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }